import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import RSelect from 'react-select';
import Textarea from 'react-expanding-textarea';
import { initialEditData, accountSelectMenuProps } from './transactionEdit';

// Shared two-row edit row (New Account, Memo, flags / Q&C, Internal Notes); edits a copy until SAVE. Styles: DataEntryIssues.css section 10.
// `flags` picks the checkboxes shown (default TFB + NBD; Uncategorized uses NBD + CPA).
const FontTooltip = withStyles(() => ({
    tooltip: {
        fontSize: 12
    },
}))(Tooltip);

const FLAGS = {
    tfb: { name: 'taxableFringeBenefit', label: 'TFB', title: 'Taxable Fringe Benefit' },
    nbd: { name: 'needsBetterDescription', label: 'NBD', title: 'Needs Better Description' },
    cpa: { name: 'cpaReview', label: 'CPA', title: 'CPA Review' }
};
const DEFAULT_FLAGS = ['tfb', 'nbd'];

class TransactionEditRow extends Component {

    constructor(props) {
        super(props);
        const editData = initialEditData(props.item);
        this.state = {
            editData: editData,
            selectedAccount: this.findAccount(editData.newAccountId, props.accountOptions)
        };
    }

    // Accounts load async: re-match the saved New Account once the options arrive.
    componentDidUpdate(prevProps) {
        if (prevProps.accountOptions !== this.props.accountOptions && this.state.editData.newAccountId) {
            this.setState({ selectedAccount: this.findAccount(this.state.editData.newAccountId, this.props.accountOptions) });
        }
    }

    findAccount = (accountId, options) => {
        const fallback = { value: 0, label: 'Select' };
        if (!accountId || !options) return fallback;
        return options.find(x => String(x.value) === String(accountId)) || fallback;
    }

    onText = (e) => {
        const editData = { ...this.state.editData, [e.target.name]: e.target.value };
        this.setState({ editData: editData });
    }

    onCheck = (e) => {
        const editData = { ...this.state.editData, [e.target.name]: e.target.checked };
        this.setState({ editData: editData });
    }

    onAccount = (option) => {
        const value = option && option.value ? option.value : 0;
        this.setState({ editData: { ...this.state.editData, newAccountId: value }, selectedAccount: option });
    }

    render() {
        const { editData, selectedAccount } = this.state;
        const { rowKey, colSpan, accountOptions, onSave, onCancel } = this.props;
        const flags = this.props.flags || DEFAULT_FLAGS;
        const id = (name) => `dei_${name}_${rowKey}`;
        return (
            <React.Fragment>
                <tr className="editRowColor dei-txn-edit-row">
                    <td colSpan={colSpan} className="dei-txn-edit-cell">
                        <div className="dei-txn-edit-inner dei-txn-edit-row-1-inner">
                            <div className="dei-txn-edit-stack dei-txn-edit-account">
                                <label>New Account</label>
                                <RSelect
                                    name="NewAccountID"
                                    value={selectedAccount}
                                    onChange={this.onAccount}
                                    options={accountOptions}
                                    placeholder="Select"
                                    {...accountSelectMenuProps()}
                                />
                            </div>
                            <div className="dei-txn-edit-stack dei-txn-edit-memo">
                                <label>Memo/Description</label>
                                <Textarea className="placheholder-color dei-txn-edit-textarea"
                                    value={editData.memoOrDescription} name="memoOrDescription"
                                    resize={"false"} placeholder=""
                                    onChange={this.onText} />
                            </div>
                            <div className="dei-txn-edit-flags">
                                {flags.filter(key => FLAGS[key]).map(key => (
                                    <FontTooltip key={key} id="tooltip-icon" title={FLAGS[key].title} placement="top">
                                        <div className="chiller_cb" style={{ marginBottom: 0 }}>
                                            <input id={id(key)} name={FLAGS[key].name} type="checkbox" checked={!!editData[FLAGS[key].name]} onChange={this.onCheck} />
                                            <label htmlFor={id(key)}><p className="checkbox-title">{FLAGS[key].label}</p></label>
                                            <span></span>
                                        </div>
                                    </FontTooltip>
                                ))}
                            </div>
                        </div>
                    </td>
                </tr>
                <tr className="editRowColor dei-txn-edit-row">
                    <td colSpan={colSpan} className="dei-txn-edit-cell">
                        <div className="dei-txn-edit-inner dei-txn-edit-row-2-inner">
                            <div className="dei-txn-edit-field dei-txn-edit-field-qc">
                                <label className="dei-txn-edit-label">Questions and Comments:</label>
                                <Textarea className="placheholder-color dei-txn-edit-textarea"
                                    value={editData.accountantComment} name="accountantComment"
                                    resize={"false"} placeholder=""
                                    onChange={this.onText} />
                            </div>
                            <div className="dei-txn-edit-field">
                                <label className="dei-txn-edit-label">Internal Notes:</label>
                                <Textarea className="placheholder-color dei-txn-edit-textarea"
                                    value={editData.internalNotes} name="internalNotes"
                                    resize={"false"} placeholder=""
                                    onChange={this.onText} />
                            </div>
                            <div className="dei-txn-edit-actions">
                                <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => onSave(editData)}>SAVE</Button>
                                <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={onCancel}>CANCEL</Button>
                            </div>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        );
    }
}

export default TransactionEditRow;
